type ConversionEvent = 'cta_click' | 'qr_click' | 'line_click' | 'form_start' | 'form_submit'

// Consent-aware analytics can subscribe to this event. No personal data or
// third-party tracking is sent by the page without a configured integration.
export function trackConversion(event: ConversionEvent, location: string) {
  window.dispatchEvent(new CustomEvent('empress:conversion', {
    detail: { event, location, campaign: 'empress_of_wellness_2026' },
  }))
}
